"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProdSysDispatcher = exports.ProdSysAction = void 0;
const tslib_1 = require("tslib");
const Utilities_1 = require("../Utilities");
const CheckList_1 = require("./CheckList");
const Excel_1 = require("./Excel");
const Powerpoint_1 = require("./Powerpoint");
// Prodsys Imports
const ProdSysBase_1 = require("./ProdSysBase");
const Syn360DegreeViewer_1 = require("./Syn360DegreeViewer");
const Visio_1 = require("./Visio");
const Word_1 = require("./Word");
const Instance_1 = require("../../model/Instance");
const WorkFlow_1 = require("./WorkFlow");
var ProdSysAction;
(function (ProdSysAction) {
    ProdSysAction[ProdSysAction["Open"] = 9] = "Open";
    ProdSysAction[ProdSysAction["View"] = 10] = "View";
})(ProdSysAction = exports.ProdSysAction || (exports.ProdSysAction = {}));
class ProdSysDispatcher {
    /**
     * Fetches the instances for ids, and does the following:
     *    If at least one of them is to be handled by a prodsys and the selcount==1, delegate to prodsys (resolve promise with true)
     *    If at least one of them is to be handled by a prodsys and the selcount>1, raise an error (reject promise). This is no allowed.
     *    If none one of them is to be handled by a prodsys do nothing (resolve promise with false).
     *
     * @param ids Ids
     * @param action Action (View or Open)
     *
     * @returns A promise that, when settled, will be either resolved to true if a prodsys handled the selection, resolved to false, if no
     * prodsys handled the selection, or rejected, if an error occured (such as multiple documents selected where one or more of them would
     * be handled by a prodsys).
     */
    static Action(ids, action, options) {
        return new Promise((resolve, reject) => tslib_1.__awaiter(this, void 0, void 0, function* () {
            let method = action === ProdSysAction.Open ? "Open" : "View";
            let idsWithVersion = [];
            if (method === "View" && options != undefined && options["version"] != undefined && options["version"]["version"] != undefined) {
                for (let i = 0; i < ids.length; ++i)
                    idsWithVersion.push(ids[i] + "|" + options["version"]["version"].toString());
            }
            else
                idsWithVersion = ids;
            let data = yield Utilities_1.synUtil.getAJAXDataAsync({
                method: "POST",
                url: Utilities_1.synUtil.getWSUrl("InstanceMultiple"),
                requestData: { ids: idsWithVersion.join(";"), properties: "cgdocument.prodid;cgdocument.stateid;cgdocument.chkout;cgdocument.doclockby", fetchContents: true }
            });
            let mapIdToInstance = {};
            for (let key in data) {
                let instJSON = data[key];
                let instance = yield Instance_1.Instance.fromJSON(instJSON);
                mapIdToInstance[key] = instance;
            }
            let mappedDispatcherDocNames = $.map(mapIdToInstance, (inst) => {
                let prodId = inst.items["cgdocument.prodid"].valueToString();
                let mappedDispatcher = ProdSysDispatcher.m_prodSysMapping[prodId];
                if (mappedDispatcher)
                    return inst.name.value || "(DocId=" + inst.items["cgdocument.docid"].value + ")";
                return undefined;
            });
            if (mappedDispatcherDocNames.length > 1 || mappedDispatcherDocNames.length === 1 && Object.keys(mapIdToInstance).length > 1) {
                let fmt = Utilities_1.synUtil.Strings.getValue("webtoolkit.customeditorcheckouterror");
                reject(kendo.format(Utilities_1.synUtil.convertFormatString(fmt), mappedDispatcherDocNames.join(", ")));
                return;
            }
            else {
                for (let instId in mapIdToInstance) {
                    let curInstance = mapIdToInstance[instId];
                    let viewconvconfirstResult = undefined;
                    if (method === "View") {
                        let strViewInsteadFieldname = Utilities_1.synUtil.Configs.getValue("viewinsteadfieldname", undefined, mapIdToInstance[instId].items["cgdocument.typeid"].valueToNumber(1));
                        if (strViewInsteadFieldname) {
                            curInstance = yield Utilities_1.synUtil.getInstanceAsync(instId);
                            if (curInstance.items[strViewInsteadFieldname] && curInstance.items[strViewInsteadFieldname].value) {
                                let referencedInstance = yield Utilities_1.synUtil.getInstanceAsync(curInstance.items[strViewInsteadFieldname].valueToString());
                                instId = referencedInstance.id.valueAsString;
                                curInstance = referencedInstance;
                            }
                        }
                        let curInstId = instId;
                        if (options && options.version && options.version.version)
                            curInstId += "|" + options.version.version.toString();
                        viewconvconfirstResult = yield Utilities_1.synUtil.getAJAXDataAsync({
                            method: "GET",
                            url: Utilities_1.synUtil.getWSUrl("ContentInstanceViewConvConFirst") + curInstId
                        });
                    }
                    if (method === "View" && viewconvconfirstResult && viewconvconfirstResult["viewconvconfirst"])
                        resolve(new ProdSysBase_1.ActionResult(false, instId));
                    else {
                        let prodId = curInstance.items["cgdocument.prodid"].valueToString();
                        let mappedDispatcher = ProdSysDispatcher.m_prodSysMapping[prodId];
                        if (mappedDispatcher)
                            resolve(mappedDispatcher[method](curInstance, options));
                        else
                            resolve(new ProdSysBase_1.ActionResult(false, instId));
                    }
                }
            }
        }));
    }
}
exports.ProdSysDispatcher = ProdSysDispatcher;
ProdSysDispatcher.m_prodSysMapping = {
    "7": Word_1.Word,
    "8": Excel_1.Excel,
    "9": Powerpoint_1.Powerpoint,
    "24": Visio_1.Visio,
    "28002": Syn360DegreeViewer_1.Syn360DegreeViewer,
    "41003": CheckList_1.Checklist,
    "41002": WorkFlow_1.Workflow,
};
